(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["waitlist-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
    var REVISION = '2026-07-15';
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function subscribe(companyId, listId, email) {
      return fetch(ENDPOINT + '?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: REVISION,
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                  },
                },
              },
            },
            relationships: { list: { data: { type: 'list', id: listId } } },
          },
        }),
      });
    }

    function init(root) {
      if (root.dataset.wlReady === 'true') return;
      root.dataset.wlReady = 'true';

      var form = root.querySelector('[data-wl-fields]');
      var input = root.querySelector('[data-wl-input]');
      var button = root.querySelector('[data-wl-submit]');
      var label = root.querySelector('[data-wl-submit-label]');
      var error = root.querySelector('[data-wl-error]');
      var success = root.querySelector('[data-wl-success]');
      if (!form || !input || !button || !label || !error || !success) return;

      var companyId = root.dataset.companyId || '';
      var listId = root.dataset.listId || '';

      function showError(message) {
        error.textContent = message;
        error.hidden = false;
        input.setAttribute('aria-invalid', 'true');
      }

      function clearError() {
        error.textContent = '';
        error.hidden = true;
        input.removeAttribute('aria-invalid');
      }

      function setState(state) {
        var busy = state === 'loading';
        root.dataset.wlState = state;
        root.setAttribute('aria-busy', busy ? 'true' : 'false');
        button.disabled = busy;
        input.disabled = busy;
        label.textContent = busy ? root.dataset.labelLoading : root.dataset.labelIdle;
      }

      input.addEventListener('input', clearError);

      form.addEventListener('submit', function (event) {
        event.preventDefault();

        if (!companyId || !listId) return;

        var email = input.value.trim();
        if (!EMAIL_RE.test(email)) {
          showError(root.dataset.errorInvalid);
          input.focus();
          return;
        }

        clearError();
        setState('loading');

        subscribe(companyId, listId, email)
          .then(function (res) {
            if (!res.ok) throw new Error('Klaviyo responded ' + res.status);

            setState('done');
            form.hidden = true;
            success.hidden = false;
            success.focus();

            document.dispatchEvent(
              new CustomEvent('waitlist:subscribed', { detail: { email: email } })
            );
          })
          .catch(function (err) {
            console.error('[waitlist] signup failed:', err);
            setState('idle');
            showError(root.dataset.errorGeneric);
            input.focus();
          });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-wl-form]').forEach(init);
    }

    initAll();

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["waitlist-nudge"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    document.addEventListener('waitlist:subscribed', function () {
      document.querySelectorAll('[data-wl-nudge]').forEach(function (el) {
        var after = el.dataset.textAfter;
        if (after) el.textContent = after;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
